module.exports = __webpack_public_path__ + "static/media/main-en.f95dec62.webp";